<template>
  <div class="file-upload-container">
    <input 
      ref="fileInput"
      type="file" 
      @change="handleFileSelect" 
      accept="*"
      style="display: none"
    />
    <button class="upload-button" @click="triggerFileInput">上传文件</button>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'FileUpload',
  methods: {
    // 触发隐藏的文件输入框
    triggerFileInput() {
      this.$refs.fileInput.click()
    },
    
    // 处理文件选择
    async handleFileSelect(e) {
      const file = e.target.files[0]
      if (file) {
        try {
          // 调用上传方法
          await this.uploadFile(file)
          // 触发父组件事件
          this.$emit('fileSelected', file)
        } catch (error) {
          console.error('文件上传失败:', error)
          this.$emit('uploadError', error)
        } finally {
          // 清空输入，允许重复上传同一文件
          e.target.value = ''
        }
      }
    },
    
    // 上传文件到后端
    async uploadFile(file) {
      // 创建 FormData 对象
      const formData = new FormData()
      formData.append('file', file)
      
      // 可以添加其他参数
      formData.append('filename', file.name)
      formData.append('uploadTime', new Date().toISOString())
      
      // 配置请求
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          // 如果有认证需求，可以添加 token
          // 'Authorization': `Bearer ${your_token}`
        },
        // 上传进度监控（可选）
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          )
          this.$emit('uploadProgress', percentCompleted)
        },
        timeout: 30000 // 30秒超时
      }
      
      // 发送请求到后端
      const response = await axios.post(
        'http://192.168.2.115:8000/upload/', // 替换为您的后端接口
        formData,
        config
      )
      
      // 返回响应数据
      return response.data
    }
  }
}
</script>

<style scoped>
.file-upload-container {
  display: inline-block;
}

.upload-button {
  padding: 8px 16px;
  background-color: #42b983; /* Vue 绿色 */
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  font-size: 14px;
}

.upload-button:hover {
  background-color: #359e75;
}

.upload-button:active {
  background-color: #2d8c65;
}
</style>